module.exports = __webpack_public_path__ + "img/blue_106.67f1559a.png";